import { Button } from '@/components/ui/button'
import { CardHeader, CardTitle, Card, CardContent } from '@/components/ui/Card'
import React from 'react'
import { Link } from 'react-router-dom'

export default function NewPasswordSuccess({ ...props }) {
  return (
    <Card {...props}>
      <CardHeader>
        <CardTitle>Password Updated</CardTitle>
      </CardHeader>

      <CardContent className="font-normal text-txt-primary">
        <p>
          Your password has been updated. You can now log in with your new
          password.
        </p>
        <Link to="/login" className="mt-3 block w-full">
          <Button size="md" className="mt-3 w-full">
            Login
          </Button>
        </Link>
      </CardContent>
    </Card>
  )
}
